var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon",class:['icon-'+_vm.type],style:({color:_vm.color,'font-size':_vm.fontSize,'background':_vm.background}),on:{"click":function($event){return _vm.onClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }